export const CATEGORY_BRP_ENTRY_COOKIE = 'gt_lp_entry_brp';

export type CategoryBrpEntry =
    | 'cars:mobile'
    | 'cars:desktop'
    | 'services:mobile'
    | 'services:desktop';

export const setCategoryBrpEntryCookie = (entry: CategoryBrpEntry) => {
    if (typeof document === 'undefined') {
        return;
    }

    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${CATEGORY_BRP_ENTRY_COOKIE}=${entry}; Max-Age=60; Path=/; SameSite=Lax${secure}`;
};
